import React, { useEffect, useState } from "react";
import { Button, Tag } from "antd";
import { vehicleService } from "../../../services";
import { Link, useParams } from "react-router-dom";
import { Gallery } from "./viewComponent/Gallery";
import Content from "./viewComponent/Content";
import { changeDocumentTitle } from "../../../utils/title";
import CardSkeleton from "../../../utils/skeleton";

const ViewCustomerVehicle = () => {

    const { id } = useParams();
    const [vehicle, setVehicle] = useState({});
    const [images, setImages] = useState([])
    const [loading, setLoading] = useState(true);
    const [customer, setCustomer] = useState({});

    const initialize = async () => {
        setLoading(true);
        const { success, data } = await vehicleService.view(id);
        setLoading(false);
        if (success) {
            setCustomer(data.customer)
            setVehicle(data.vehicle);
            setImages(data.images)
        }
    };

    useEffect(() => {
        changeDocumentTitle("View Vehicle");
        initialize();
    }, [id]);
    const validStatuses = ["LOADED", "AT YARD", "LOAD PLAN", "RETURNED"];

    const statusColors = {
        LOADED: "green",
        "AT YARD": "gold",
        "LOAD PLAN": "blue",
        RETURNED: "red",
    };
    return (
        <div className="flex w-full  justify-between gap-3">
            {/* LEFT: Fixed Section */}
            <div className="w-1/2 sticky top-0 self-start">
                <h1 className="mb-2 font-bold text-base">{vehicle.vehicle}</h1>
                <div className="flex items-center justify-between">
                    <p className="font-medium text-sm">{vehicle.chasis_no}</p>
                </div>

                {/* Tags */}
                <div className="mt-2 space-x-1">

                    {validStatuses.includes(vehicle?.car_status) ? (
                        <Tag color={statusColors[vehicle.car_status]}>
                            {vehicle.car_status}
                        </Tag>
                    ) : null}


                    {(!vehicle?.title || vehicle?.title === "NO") ? (
                        <Tag color="yellow">Title Not Available</Tag>
                    ) : (
                        <Tag color="green">Title Available</Tag>
                    )}

                    {vehicle?.keys === "NO" ? (
                        <Tag color="gray" className="text-black">
                            Keys Missing
                        </Tag>
                    ) : vehicle?.keys === "YES" ? (
                        <Tag color="green">Keys Available</Tag>
                    ) : vehicle?.keys === "BROKEN" ? (
                        <Tag color="red">Keys Broken</Tag>
                    ) : null}
                </div>

                <div className="w-full mt-3">
                    <Gallery images={images} chassis={vehicle.chasis_no} loading={loading} />
                </div>

                {/* Notes */}
                {/* {vehicle?.notes && ( */}
                <div className="border mt-2 p-4 w-full bg-white rounded-lg">

                    {loading ?
                        <div className='p-3'>
                            <CardSkeleton />
                        </div>
                        :
                        <div>
                            <p className="font-semibold">Notes</p>
                            <p className="w-full break-words whitespace-pre-line">
                                {vehicle?.notes}
                            </p>
                        </div>
                    }
                </div>
                {/* )} */}


            </div>

            {/* RIGHT: Scrollable Section */}
            <div className="flex-1 mt-[54px] w-full">
                <div className="flex justify-end gap-3 mb-4">
                    <Button className="rounded-2xl">Print</Button>
                    <Link to={"/vehicle"}>
                        <Button className="rounded-2xl">Back to List</Button>
                    </Link>
                </div>
                <Content data={vehicle} loading={loading} customer={customer} />
            </div>
        </div>
    )

}
export default ViewCustomerVehicle